export default "__VITE_ASSET__5d8707cf__"